
const getImgPath = (img: string) => `${window.origin}/assets/img/${img}`;

export { getImgPath };
